import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import PayoutsTable from "../../components-bootstrap/PayoutsTable";

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function TabsCTO({ allCTODataValues = {} }) {
  const allCTOTableColumns = [
    {
      dataField: "uid",
      text: "Invoice Id",
    },
    {
      dataField: "gym_name",
      text: "Gym name",
      formatter: (cell, row) => (
        <span className="tdData">{row.gym_name ? row.gym_name : "---"}</span>
      ),
    },
    {
      dataField: "cto_name",
      text: "CTO Name",
      formatter: (cell, row) => {
        const colorCombinations = [
          { background: "rgba(255, 195, 39, 0.40)", color: "#EB4A16" },
          { background: "rgba(255, 143, 107, 0.40)", color: "#DE2929" },
          { background: "rgba(61, 111, 210, 0.40)", color: "#1B50BA" },
          { background: "rgba(190, 49, 239, 0.40)", color: "#8D15B8" },
        ];

        const randomCombination =
          colorCombinations[
            Math.floor(Math.random() * colorCombinations.length)
          ];

        const spanStyle = {
          backgroundColor: randomCombination.background,
          color: randomCombination.color,
          textTransform: "capitalize"
        };

        return (
          <span className="tdBolder borderRadius" style={spanStyle}>
            {row.cto_name?.replace(/_/g, " ") || "----"}
          </span>
        );
      },
    },
    // {
    //     dataField: "cto_name",
    //     text: "CTO Name",
    //     formatter: (cell, row) => (
    //         <span
    //             className='tdBolder borderRadius'
    //             style={{
    //                 backgroundColor: row.cto_name === "WTF Salary" ? "#FFC327" :
    //                     row.cto_name === "Laptop EMI" ? "#3D6FD2" :
    //                         row.cto_name === "House Rent" ? "#FF8F6B" :
    //                             row.cto_name === "Water Bill" ? "#BE31EF" :
    //                                 "#FFC327",
    //                 color: row.cto_name === "WTF Salary" ? "#EB4A16" :
    //                     row.cto_name === "Laptop EMI" ? "#1B50BA" :
    //                         row.cto_name === "House Rent" ? "#DE2929" :
    //                             row.cto_name === "Water Bill" ? "#8D15B8" :
    //                                 "#EB4A16",
    //             }}
    //         >
    //             {row.cto_name || "----"}
    //         </span>
    //     ),
    // },
    {
      dataField: "document",
      text: "Document",
      formatter: (cell, row) => (
        <span className="tdData">{row.document ? "Yes" : "No"}</span>
      ),
    },
    {
      dataField: "cto_type",
      text: "CTO Type",
      formatter: (cell, row) => (
        <span className="tdData" style={{ textTransform: "uppercase" }}>
          {row.cto_type || "---"}
        </span>
      ),
    },
    {
      dataField: "month",
      text: "CTO Month",
      formatter: (cell, row) => (
        <span className="tdData">
          {row.month ? monthNames[row.month - 1] : "---"}
        </span>
      ),
    },
    {
      dataField: "year",
      text: "CTO Year",
      formatter: (cell, row) => (
        <span className="tdData">{row.year || "---"}</span>
      ),
    },
    {
      dataField: "cost",
      text: "CTO Cost",
      formatter: (cell, row) => (
        <span className="tdData tdBolder">₹{row.cost || "---"}</span>
      ),
    },
  ];

  return (
    <div className="tabsCtoContainer">
      <Tabs defaultActiveKey="all" id="uncontrolled-cto-tab" className="">
        <Tab eventKey="all" title="All">
          <PayoutsTable
            columnsValues={allCTOTableColumns}
            dataValues={allCTODataValues.allCTOData}
          />
        </Tab>
        <Tab eventKey="wtf" title="WTF">
          <PayoutsTable
            columnsValues={allCTOTableColumns}
            dataValues={allCTODataValues.wtfCTOData}
          />
        </Tab>
        <Tab eventKey="gyn" title="GYM">
          <PayoutsTable
            columnsValues={allCTOTableColumns}
            dataValues={allCTODataValues.gymCTOData}
          />
        </Tab>
      </Tabs>
    </div>
  );
}

export default TabsCTO;
